import React from 'react'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(100)};
  width: 100%;
  aspect-ratio: 3.3 / 1;
  overflow: hidden;
`

function HelloFreshModalImage() {
  return (
    <ImageContainer>
      <Image
        image={{ id: 'hello-fresh-promo' }}
        fit="center"
        objectFit="cover"
        alt="Hello Fresh Modal Image"
      />
    </ImageContainer>
  )
}

export default HelloFreshModalImage
